import React from 'react';

type LandingLogoProps = {
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
  className?: string;
  /** Rounded frame — matches auth/landing template logo badge */
  frame?: boolean;
};

export const LandingLogo: React.FC<LandingLogoProps> = ({
  size = 'md',
  showText = true,
  className = '',
  frame = false,
}) => {
  const imgSize = size === 'sm' ? 'w-7 h-7' : size === 'lg' ? 'w-12 h-12' : 'w-9 h-9';
  const textSize = size === 'sm' ? 'text-lg' : size === 'lg' ? 'text-3xl' : 'text-xl';

  const logoImg = (
    <img
      src="/assets/logo2.svg"
      alt="ChatX"
      className={frame ? 'w-full h-full object-cover' : `${imgSize} shrink-0 object-contain`}
    />
  );

  return (
    <span className={`flex items-center gap-2.5 ${className}`}>
      {frame ? (
        <span
          className={`relative grid place-items-center ${imgSize} rounded-2xl overflow-hidden shrink-0`}
        >
          {logoImg}
        </span>
      ) : (
        logoImg
      )}
      {showText && (
        <span className={`app-logo-word ${textSize} font-extrabold tracking-tight`}>
          Chat<span className="text-brand2">X</span>
        </span>
      )}
    </span>
  );
};
